var host = "https://api.mohammadmainulislam.com";

const { h } = require("vue");

module.exports = {
    V1API: {
        'getAccessToken': host + '/api/auth/token',
        'refreshAccessToken': host + '/api/auth/token/refresh/',
        'verifyLogin': host + '/api/auth/token/verify',

        // Portfolio
        // Blog
        'blog_list':host+'/api/blog/list',
        'create_blog':host+'/api/blog/create',
        'get_blog_details':host+'/api/blog/getdetail/slug',
        'update_blog':host+'/api/blog/update/',
        'blog_delete':host+'/api/blog/delete/',

        // Media Appearances
        'media_list':host+'/api/media_appearance/list',
        'create_media':host+'/api/media_appearance/create',
        'get_media_details':host+'/api/media_appearance/detail/slug',
        'update_media':host+'/api/media_appearance/update/',
        'media_delete':host+'/api/media_appearance/delete/',

        // Collaboration
        'collaboration_list':host+'/api/collaboration/list',
        'create_collaboration':host+'/api/collaboration/create',
        'get_collaboration_details':host+'/api/collaboration/getdetail/',
        'update_collaboration':host+'/api/collaboration/update/',
        'collaboration_delete':host+'/api/collaboration/delete/',

        // Affiliations
        'affiliation_list':host+'/api/affiliation/list',
        'create_affiliation':host+'/api/affiliation/create',
        'get_affiliation_details':host+'/api/affiliation/getdetail/',
        'update_affiliation':host+'/api/affiliation/update/',
        'affiliation_delete':host+'/api/affiliation/delete/',

        // Gallery
        'gallery_list':host+'/api/gallery/list',
        'create_gallery':host+'/api/gallery/create',
        'get_gallery_details':host+'/api/gallery/detail/',
        'update_gallery':host+'/api/gallery/update/',
        'gallery_delete':host+'/api/gallery/delete/',

        // Publications
        'publication_list':host+'/api/publication/',
        'create_publication':host+'/api/publication/create',
        'get_publication_details':host+'/api/publication/detail/',
        'update_publication':host+'/api/publication/update/',
        'publication_delete':host+'/api/publication/delete/',
        'publication_category':host+'/api/publication/category/list',

        // Contact
        'contact_list':host+'/api/contact/message/list',
        'contact_delete':host+'/api/contact/delete/',

        // Recents
        'recent_list':host+'/api/recent/list',
        'create_recent':host+'/api/recent/create',
        'get_recent_details':host+'/api/recent/getdetail/',
        'update_recent':host+'/api/recent/update/',
        'recent_delete':host+'/api/recent/delete/',

        // Contact Info
        'create_contact_info':host+'/api/contact/info/create/',
        'get_contact_info_details':host+'/api/contact/info',

        // Bio
        'get_bio_details':host+'/api/personal-info/bio/list',
        'create_bio':host+'/api/personal-info/bio/create/',

        // Education
        'education_list':host+'/api/personal-info/edu/list',
        'create_education':host+'/api/personal-info/edu/create/',
        'get_education_details':host+'/api/personal-info/edu/details/',
        'update_education':host+'/api/personal-info/edu/update/',
        'education_delete':host+'/api/personal-info/edu/delete/',

        // Experience
        'experience_list':host+'/api/personal-info/exp/list',
        'create_experience':host+'/api/personal-info/exp/create/',
        'get_experience_details':host+'/api/personal-info/exp/details/',
        'update_experience':host+'/api/personal-info/exp/update/',
        'experience_delete':host+'/api/personal-info/exp/delete/',

        // Teaching
        'teaching_list':host+'/api/personal-info/teach/list',
        'create_teaching':host+'/api/personal-info/teach/create/',
        'get_teaching_details':host+'/api/personal-info/teach/details/',
        'update_teaching':host+'/api/personal-info/teach/update/',
        'teaching_delete':host+'/api/personal-info/teach/delete/',

        // Awards
        'award_list':host+'/api/personal-info/award/list',
        'create_award':host+'/api/personal-info/award/create/',
        'get_award_details':host+'/api/personal-info/award/details/',
        'update_award':host+'/api/personal-info/award/update/',
        'award_delete':host+'/api/personal-info/award/delete/',

        // Training
        'training_list':host+'/api/personal-info/training/list',
        'create_training':host+'/api/personal-info/training/create/',
        'get_training_details':host+'/api/personal-info/training/details/',
        'update_training':host+'/api/personal-info/training/update/',
        'training_delete':host+'/api/personal-info/training/delete/'
    }
};
